import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DoorData {
  featureId: string;
  textField: string;
  camera_id?: string;
}

export interface DashboardData {
  door_name: string;
  feature_id: string;
  map_data: MapData;
  table_data: DoorData[];
  google_api_key: string;
}

export interface MapData {
  coords: [number, number];
  all_doors: {
    featureId: string;
    doorName: string;
    coords: [number, number];
  }[];
  room_geojson?: string;
  room_labels?: {
    name: string;
    coords: [number, number];
  }[];
}

export interface HistoryRecord {
  date: string;
  description: string;
  door_name: string;
  user_name: string;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getDashboardData(featureId: string): Observable<DashboardData> {
    return this.http.get<DashboardData>(`${this.apiUrl}/dashboard/${featureId}`);
  }

  unlockDoor(featureId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/unlock_door`, { feature_id: featureId });
  }

  viewCamera(featureId: string): Observable<string> {
    return this.http.post(`${this.apiUrl}/view_camera`, { feature_id: featureId }, { responseType: 'text' });
  }

  viewHistory(featureId: string): Observable<HistoryRecord[]> {
    return this.http.post<HistoryRecord[]>(`${this.apiUrl}/view_history`, { feature_id: featureId });
  }
}
